import { FunctionComponent, useState } from "react";

import { CircularProgress, IconButton } from "@mui/material";

import { faPlay } from "@fortawesome/pro-regular-svg-icons";

import { t } from "i18next";

import { Icon, Modal } from "@/components";
import { usePageTitle } from "@/utils/usePageTitle";

export const Tutorials: FunctionComponent = () => {
	const [isLoading, setIsLoading] = useState(false);
	const [isVideoModalOpen, setIsVideoModalOpen] = useState(false);
	const [currentVideoUrl, setCurrentVideoUrl] = useState("");

	const ts = (key: string) => t(`sidebar.${key}`);
	const tt = (key: string) => t(`tutorials.${key}`);

	usePageTitle(ts("tutorials"));

	const isControlsEnabled = true;

	function handleVideoModal(item: string) {
		setIsVideoModalOpen(true);
		setCurrentVideoUrl(item);
	}

	return (
		<>
			{isLoading ? (
				<div className="w-full flex-1 flex items-center justify-center">
					<CircularProgress className="!w-16 !h-16 !text-primary-gray" />
				</div>
			) : (
				<div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 w-full gap-4 p-4 ">
					<div
						className="hover:cursor-pointer bg-white flex flex-col flex-1 min-h-full relative"
						onClick={(e) => {
							handleVideoModal(
								"https://crisis-dev.nbg1.your-objectstorage.com/crisis-dev/s6pu4jbe6mw6/public/1745852185181-course-trailer-video.mp4"
							);
						}}
					>
						<h4 className="font-semibold text-[14px] mb-2 ml-2">{tt("title")}</h4>
						<video
							className={` min-h-fit rounded-[1.25rem] `}
							controls={!isControlsEnabled}
							src="https://crisis-dev.nbg1.your-objectstorage.com/crisis-dev/s6pu4jbe6mw6/public/1745852185181-course-trailer-video.mp4"
						/>

						{isControlsEnabled && (
							<IconButton
								className="flex items-center justify-center"
								style={{
									position: "absolute",
									top: "50%",
									left: "50%",
									transform: "translate(-50%, -50%)",
									backgroundColor: "rgba(0, 0, 0, 0.5)",
									color: "white",
									fontSize: "2rem",
									width: "40px",
									height: "40px",
								}}
							>
								<Icon className="-mr-1" icon={faPlay} size="sm" />
							</IconButton>
						)}
					</div>
				</div>
			)}

			{isVideoModalOpen && (
				<Modal
					dialogContentClassName="!p-2 min-h-[100%] overflow-auto scrollbar-hide relative"
					handleClose={() => {
						setIsVideoModalOpen(false);
						setCurrentVideoUrl("");
					}}
					isOpened={isVideoModalOpen}
					showActions={false}
					size="lg"
					title=""
				>
					<div>
						<video
							autoPlay={true}
							className={` min-h-fit rounded-[1.25rem] `}
							controls={isControlsEnabled}
							src={currentVideoUrl}
						/>
					</div>
				</Modal>
			)}
		</>
	);
};
